



const convertir = (value: number | string): string => {
    if (typeof (value) === "string") value = Number(value);
    return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 2,
    }).format(value);
}

const MonedaTool = {
    convertir
}

export default MonedaTool;